import React from 'react';
import { useTranslation } from "react-i18next";
import { Container, Grid } from '@material-ui/core';
import './resume.css';

/**
 * @description summary of registration process for the user.
 * @status no delete
 * @param {*} props
 * @return {*}
 */
const ResumeView = (props) => {
  const { t, i18n } = useTranslation();

  return (
    <Container spacing={4} lg={12} md={12} sm={12} xs={12} style={{ maxWidth: '100%' }}>
      <Grid container spacing={2}>
        {/* Registration Completion Message */}
        <Grid item xs={12}>
          <div className='registration-completion-message'>
            <div className='message-content'>
              <div className='checkmark-circle'>
                <span className='checkmark'>✔</span>
              </div>
              <p>Has finalizado el proceso de registro. Una vez que quede verificado tu pago, te enviaremos un correo confirmando la activación de tu cuenta.</p>
            </div>
          </div>
        </Grid>
        {/* Business Plan Details */}
        <Grid item xs={12}>
          <div className='business-plan-details'>
            <h2>PLAN EMPRESARIAL</h2>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <p><strong>Solicitado por</strong><br />{props.firstName} {props.firstLastName} {props.secondLastName}</p>
                <p><strong>Número de teléfono</strong><br />{props.cellphoneNumber}</p>
              </Grid>
              <Grid item xs={12} sm={6}>
                <p><strong>Método de pago</strong><br />Trato directo</p>
                <p><strong>Inicio del plan</strong><br />Sin definir</p>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className='resume-text-form-pay'>
            <p>
              Gracias por contratar nuestro servicio de govo.legal,
              Mientras tanto te damos los siguientes consejos para un mejor uso del sistema.
            </p>
            {/* <p>Paquete contratado <span className='plan-text'>{(props.assignedPackage[0]) ? (props.assignedPlans[0]) ? (props.assignedPlans[0] && props.assignedPackage[0]) ? props.assignedPlans[0].name + ' y ' + props.assignedPackage[0].name : null : props.assignedPackage[0].name : props.assignedPlans[0].name}</span></p> */}
            <p>Al contratar el servicio además de poder hacer uso de todas las características de govo.legal, también adquieres un perfil de administrador, el cual te permite agregar, en la opción de configuración, a tus Firmantes Colaboradores, así como
              también a otros usuarios Administradores si así lo deseas.
            </p>
            <p>Un usuario Administrador tiene las facultades de agregar Requerimientos de Firma y a su vez a otros Firmantes Colaboradores e Invitados, además de poder definir Colaboradores que podrán autorizar los documentos previo a la acción de la Firma</p>
            <p>El usuario Invitado tiene la facultad de entrar a firmar un Requerimiento de Firma.</p>
            <p>Si tu empresa tiene varios dominios de cuentas de correo electrónico, ejemplo: usuario1@acme.com, usuario2@acme.com.mx, etc. puedes agregar más dominios para invitar a los colaboradores de tu empresa ya que por default se agrega solo el dominio
              de tu correo, por lo que solo podrás agregar colaboradores con el mismo dominio.
            </p>
            <p>Al usar firmas autógrafas digitales, es una buena práctica contar con firmas base, que le podrán servir de referencia comparativa a un perito en caso de controversia (por ejemplo, identificaciones oficiales). Podrás incluirla en tu perfil, esto le dará mayor
              fiabilidad a tu firma digital.
            </p>
            <span>Gracias.</span>
          </div>
        </Grid>
      </Grid>
    </Container>
  )
}

export { ResumeView as default }
